import { API } from 'services';

export function createInvite(params) {
  return API({
    method: 'POST',
    endpoint: '/invite',
    ...params,
  });
}

export function getInvites(params) {
  const queryParams = new URLSearchParams(params).toString();

  return API({
    endpoint: `/invite?${queryParams}`,
  });
}

export function getInvitesProvider(params) {
  const queryParams = new URLSearchParams(params).toString();

  return API({
    endpoint: `/invite/provider?${queryParams}`,
  });
}

export function getInvitePreview({ token, ...params }) {
  return API({
    endpoint: `/invite/preview/${token}`,
    ...params
  });
}

export function updateInvite({ token, ...params }) {
  return API({
    method: 'PUT',
    endpoint: `/invite/${token}`,
    ...params
  });
}

export function deleteInvite({ token, ...params }) {
  return API({
    method: 'DELETE',
    endpoint: `/invite/${token}`,
    ...params
  });
}

export function acceptInvite({ token, ...params }) {
  return API({
    method: 'POST',
    endpoint: `/invite/accept/${token}`,
    ...params
  });
}
